/* eslint complexity: 0 */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import isComponentOfType from 'utils/is-component-of-type';
import styles from './button.less';

const buttonGroupFactory = (Button, Select) => {
  class ButtonGroup extends PureComponent {
    static propTypes = {
      align: PropTypes.oneOf(['left', 'center', 'right']),
      children: PropTypes.node,
      className: PropTypes.string,
      danger: PropTypes.bool,
      dark: PropTypes.bool,
      direction: PropTypes.oneOf(['row', 'column']),
      disabled: PropTypes.bool,
      flex: PropTypes.bool,
      full: PropTypes.bool,
      gutter: PropTypes.oneOfType([
        PropTypes.oneOf(['left', 'right']),
        PropTypes.bool,
      ]),
      primary: PropTypes.bool,
      reverse: PropTypes.bool,
      size: PropTypes.oneOf(['xs', 'sm', 'm', 'lg', 'xl']),
      style: PropTypes.object,
      theme: PropTypes.oneOf(['raised', 'flat']),
    };

    static defaultProps = {
      className: '',
      direction: 'row',
      gutter: false,
      size: 'm',
    };

    renderChildren() {
      return React.Children.map(this.props.children, child => {
        const _className = classnames(
          styles['group-item'],
          child.props.className
        );

        // If the child is a Button component, decorate with props from the button group
        if (isComponentOfType(Button, child)) {
          return React.cloneElement(child, {
            align: this.props.align || child.props.align,
            className: _className,
            danger: this.props.danger || child.props.danger,
            dark: this.props.dark || child.props.dark,
            disabled: this.props.disabled || child.props.disabled,
            flex: this.props.flex || child.props.flex,
            full:
              this.props.full ||
              this.props.direction === 'column' ||
              child.props.full,
            gutter: false,
            primary: this.props.primary || child.props.primary,
            reverse: this.props.reverse || child.props.reverse,
            size: this.props.size || child.props.size,
            theme: this.props.theme || child.props.theme,
          });
        }

        // If the child is a Select component, decorate with props from the button group
        if (isComponentOfType(Select, child)) {
          return React.cloneElement(child, {
            className: _className,
            disabled: this.props.disabled || child.props.disabled,
            flex: this.props.flex || child.props.flex,
            primary: this.props.primary || child.props.primary,
            size: this.props.size || child.props.size,
            theme: this.props.theme || child.props.theme,
          });
        }

        return child;
      });
    }

    render() {
      const { className, direction, gutter, style } = this.props;

      const _className = classnames(
        styles.group,
        {
          [styles['group-gutter--left']]: gutter === 'left' || gutter === true,
          [styles['group-gutter--right']]:
            gutter === 'right' || gutter === true,
          [styles[`group--${direction}`]]: direction,
        },
        className
      );

      return (
        <div
          data-test-id="button-group"
          className={_className}
          {...(style && { style })}
        >
          {this.renderChildren()}
        </div>
      );
    }
  }

  return ButtonGroup;
};

export default buttonGroupFactory;
export { buttonGroupFactory };
